import $ from 'jquery';
import 'FitText.js'; // eslint-disable-line
import './stats.scss';

class Stats {
  constructor(element) {
    this._mobileMedia = matchMedia('(max-width:767px)');
    this._onMediaChange = this._handleMediaQueryChange.bind(this);
    this._$text = $(element).find('.js-fit-text');

    Object.defineProperty(this, 'isSmallScreen', {
      get() {
        return this._mobileMedia.matches;
      },
    });

    this._mobileMedia.addListener(this._onMediaChange);

    if (this.isSmallScreen) {
      this._fitText();
    }
  }

  _handleMediaQueryChange() {
    if (this.isSmallScreen) {
      this._fitText();
    } else {
      this._removeFitText();
    }
  }

  _fitText() {
    this._$text.fitText(0.4, {
      minFontSize: '40px',
      maxFontSize: '104px',
    });
  }

  _removeFitText() {
    $(window).off('.fittext');
    this._$text.css('fontSize', '');
  }

  dispose() {
    this._mobileMedia.removeListener(this._onMediaChange);
    this._$text = null;
  }

  static initializeAll() {
    return $('.stats').map((i, el) => new Stats(el)).get();
  }
}

Stats.initializeAll();

export default Stats;
